import { SET_TRAINING_STATUS, SET_TRAINING_SUCCESS } from './TCTrainingStatusActions';

const initialState = {
  completed: undefined,
  success: false,
};

const trainingStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRAINING_STATUS:
      return {
        ...state,
        completed: action.payload,
      };
    case SET_TRAINING_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };
    default:
      return state;
  }
};

export default trainingStatusReducer;
